// https: //static.zdassets.com/ekr/snippet.js?key=deace1ff-ebf2-4918-a3ad-69724a621288

window.initializeZendeskWidget = () => {
  const zendeskKey = $("body").attr("data-zendesk-key");

  if (zendeskKey && zendeskKey.length > 0) {
    window.zEmbed = window.zE = undefined;
    window.zEACLoaded = undefined;

    $('head script[src*="zdassets"]').remove();
    $('head iframe[src="javascript:false"]').remove();
    $("[__jx__id], embed#__zopnetworkswf").remove();
    window.$zopim = undefined;
    setTimeout(
      () =>
        $("head").append(`
      <script async id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}" >
    `),
      1000
    );
  }

  let zendeskElement = document.getElementById("zendeskMobileLauncher");
  if (zendeskElement) {
    zendeskElement.removeEventListener("click", openZendeskWidget);
    zendeskElement.addEventListener("click", openZendeskWidget);
  }
};

const openZendeskWidget = () => {
  let elem = document.getElementById("hamburgerMenu");
  elem.click();

  zE("webWidget", "show");
  zE("webWidget", "open");
};
